import Axios from "axios";

export const callSalesPeople = async () => {
  try {
    
    
    const { data }: { data: any } = await Axios.post(
      `/api/utility/salesPeople`,
      {

      }, 
      
    );

    return { ...data, success: true };
  } catch (error) {
    const response: any = error;
    if (response) {
      return {
        success: false,
        id: response.id,
        firstName: response.firstName,
        lastName: response.lastName

      };
    } else {
      return {
        success: false,
        id: null,
        firstName: "",
        lastName: ""
      };
    }
  }
};